import { Component, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';
import { ApiResponse } from '../models/APIResponse';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {

  username: string;
  userNotFound: boolean;
  message: string;

  constructor(private loginService: LoginService, private router: Router) { }

  ngOnInit() {
  }

  forgetPassword(username) {
    this.userNotFound = false;
    this.message = "";
    this.loginService.resetPassword(username)
      .subscribe((res: ApiResponse) => {
        if (res.success) {
          this.router.navigate(['/Login'], { queryParams: { resetmsg: 'Email with reset instructions has been sent to your account email address!' } });
        } else {
          this.userNotFound = true;
          this.message = res.message;
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/forget-password/forget-password.component.ts